import IconLocationOffLine from "../SvgIcon/IconLocationOffLine";

export default function NoRecordsCard({ title, subtitle, icon }) {
  return (
    <div className="usercard not-found-card text-center d-flex flex-column align-items-center justify-content-center">
      {/* <img src="../images/notfound.png" className="w-75" alt="notfound" /> */}
      <IconLocationOffLine />
      <h4>{title}</h4>
      <p className="mb-0">{subtitle}</p>
    </div>
  )
}
